import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import qs from "qs";
import { ApiConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";

export default function useRemoveChannelMember() {
  const { t: getLabel } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ groupId, memberId }) => {
      const payload = qs.stringify(HumpUtils.decamelizeKeys({ groupId, memberId }));
      const response = await ApiUtils.createApiWithToken(false).post(ApiConstant.DELETE_CHANNEL, payload);
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { onResetMembers, onSuccess }) => {
      if ([ApiConstant.STT_OK, ApiConstant.STT_BAD_REQUEST].includes(response?.status)) {
        SystemUtils.appendNotification(getLabel("TXT_REMOVE_CHANNEL_MEMBER_SUCCESS"), "success");
        await queryClient.invalidateQueries(ApiConstant.REACT_QUERY_KEYS.getChannelList);
        onResetMembers?.();
        onSuccess?.();
      } else {
        SystemUtils.appendNotification(getLabel("TXT_REMOVE_CHANNEL_MEMBER_FAIL"), "error");
      }
    },
    onError: () => {
      SystemUtils.appendNotification(getLabel("TXT_TIMEOUT"), "error");
    },
  });

  const removeChannelMember = payload => {
    mutation.mutate(payload);
  };

  return { removeChannelMember, isLoading: mutation.isLoading };
}
